import gql from 'graphql-tag';

import type { BrandTerm } from 'src/data/brandTerm';
import { executeGqlQuery } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendQueryBrandTermsArgs } from 'src/types/backend';

import { FRAGMENT_BRAND_TERM } from './schema';

const QUERY = gql`
  query BrandTerms($brandVoiceId: ID!) {
    brandTerms(brandVoiceId: $brandVoiceId) {
      ...BrandTerm
    }
  }
  ${FRAGMENT_BRAND_TERM}
`;

type Variables = Pick<BackendQueryBrandTermsArgs, 'brandVoiceId'>;
type Result = BrandTerm[];

export const queryBrandTerms = async (variables: Variables): Promise<Result | undefined> => {
  const result = await executeGqlQuery({
    query: QUERY,
    variables,
  });
  return getSingleProp<Result>(result.data);
};
